module.exports = __webpack_public_path__ + "images/decoration_light.a554c6c4.svg";